import { render, staticRenderFns } from "./ProductInStockLocationListing.vue?vue&type=template&id=c5067e98&scoped=true"
import script from "./ProductInStockLocationListing.vue?vue&type=script&lang=js"
export * from "./ProductInStockLocationListing.vue?vue&type=script&lang=js"
import style0 from "./ProductInStockLocationListing.vue?vue&type=style&index=0&id=c5067e98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5067e98",
  null
  
)

export default component.exports